import { BaseCrudComponent } from '../base';
import { SelectItem, MenuItem } from 'primeng/primeng';
import { environment } from 'environments/environment';
import { Validators, FormArray } from '@angular/forms';
import { ResumoHomologacaoCurso } from '../entity/resumo-homologacao.model';
import { Situacoes, TipoDecisao } from 'app/entity/enumeraveis';
import { Component } from '@angular/core';
import { HomologacaoEvento } from 'app/entity/homologacao-evento.model';
import { RascunhoDeJulgamento } from 'app/entity/rascunho-de-julgamento.model';
import { PontuacaoRascunhoDeJulgamento } from 'app/entity/pontuacao-rascunho-de-julgamento.model';

@Component({ template: '' })
export class HomologacaoAtividadeComponent extends BaseCrudComponent {
    pontuacaoNaturezaMinima: any;
    etapaPontuacao = 3
    listaPntCFC: any[];
    listaPntCRC: any[];
    listaPntCFCEvento: any[];
    listaPntCRCEvento: any[];
    pontuacaoNaturezaMaxima: any;
    dataVigencia: Date;
    resumoHomologacao: ResumoHomologacaoCurso = new ResumoHomologacaoCurso();
    modal: number;
    listaResumo: SelectItem[] = [];
    pontuacaoNatureza = 0;
    listaAtividade: SelectItem[] = [];
    listaValorAtividade: any[] = [];
    deferido: string = 'Deferimento';
    isValid = false;
    nomeCapacitadora: string;
    nomeInstituicao: string;
    pendente = false;
    AptoNApto = false;
    pontuacao_homologacao_atividade: FormArray;
    contador = 0;
    pontuacao_conteudo_evento: FormArray; //pontuacao por evento ind.
    decisaoComissaoCrc: any;
    disabledCheckbox: boolean;
    listaRelatores: SelectItem[] = [];

    anos: number;
    etapa = 0;
    etapas: MenuItem[] = [
        { label: 'Em homologação no CRC - Gestor' },
        { label: 'Em homologação no CRC - Comissão' },
        { label: 'Em homologação no CFC - Gestor' },
        { label: 'Em homologação no CFC - Comissão' }
    ];
    listaUsuarioPedencia: any = [
        { nome: 'Profissional', id: 1 },
        { nome: 'Gestor CRC', id: 2 }
    ];
    mostrarGestor = false;
    liberarBtns: boolean = false;
    textoDeferimento = '';

    cadastro = this.formBuilder.group({
        pontuacao_homologacao_atividade: this.formBuilder.array([]),
        pontuacao_conteudo_evento: this.formBuilder.array([]), //pontuacao por evento ind.
        id: [null],
        id_atividade_natureza: [null, [Validators.required]],
        id_situacao: [null],
        observacao: [null, [Validators.required, Validators.maxLength(4000)]],
        id_usuario_receptor: [null, [Validators.required]],
        id_usuario_emissor: [null],
        data_julgamento: [new Date],
        id_pendencia: [null, [Validators.required]]
    });

    init() {
        this.observableUser.getValue.subscribe(
            usuario => {
                if (usuario && usuario !== '') {
                    const dadoUsuario = usuario.obj
                    this.cadastro.get('id_usuario_emissor').setValue(dadoUsuario.id);
                }
            },
            error => (error.status === 403) ? window.location.href =
                `${environment.apiEndpoint}/api/Autenticar/login` : null
        );
    }
    afterLoad() {
        this.contador = this.obj.contador !== undefined ? this.obj.contador : 0;
        this.cadastro.get('pontuacao_homologacao_atividade').patchValue(this.obj.pontuacao_homologacao_atividade);
        const id = this.cadastro.get('id').value;
        this.service.ListarPontuacaoHomologacao(this.controllerName, id, 'Comissão CRC').subscribe(retorno => {
            this.listaPntCRC = retorno;
        });
        this.service.ListarPontuacaoHomologacao(this.controllerName, id, 'Comissão CFC').subscribe(retorno => {
            this.listaPntCFC = retorno;
        });

        //Carrega pontuacoes por conteudo/evento
        this.service.ListarHomologacaoConteudoEvento(this.controllerName, id, "Comissão CRC").subscribe(retorno => {
            this.listaPntCRCEvento = retorno;
        });
        this.service.ListarHomologacaoConteudoEvento(this.controllerName, id, "Comissão CFC").subscribe(retorno => {
            this.listaPntCRCEvento = retorno;
        });

        this.CarregarListaResumo();
        this.verificaEtapa();
        this.carregarListaRelatores();
    }
    carregarListaRelatores() {
        this.service.ListarRelatores('listaRelatoresHomologacao', { query: this.obj.id }).subscribe(
            data => {
                this.listaRelatores = data;
            }
        );
    }
    /**
     * Carrega as naturezas ligadas atividade do parametro.
     * @param atividade nome da atividade
     */
    carregarlistAtividade(atividade: string, id_atividade: number) {
        this.service.ListarTodos('natureza', { query: atividade, id_natureza: id_atividade }).subscribe(data => {
            this.listaAtividade = data;
            this.listaValorAtividade = data;
        });
    }

    /**
     * Método que lista as pontuações parametrizadas em Pontuação.
     * @param atividadeHomologacao nome da atividade da homologação Ex: Se a homologacao e de docencia entao a atividade é docencia
     */
    carregarPontuacaoCadastro(atividadeHomologacao: string, id_atividade: string, rascunhoFinal: any) {
        this.service.ListarPorAtividadeAvulsas('atividadePontuacao', { query: atividadeHomologacao, id_atividade: id_atividade }).subscribe(
            data => {
                let i = 0;
                const ultimoRegistro = data.length - 1;
                this.anos = data[ultimoRegistro].pontuacao.norma.ano_exercicio;

                this.pontuacao_homologacao_atividade = this.cadastro.controls['pontuacao_homologacao_atividade'] as FormArray;
                this.pontuacao_conteudo_evento = this.cadastro.controls['pontuacao_conteudo_evento'] as FormArray;
                data.forEach(pontuacao => {
                    const pontoResgatado = rascunhoFinal
                        ? rascunhoFinal.pontuacao_rascunho_de_julgamento.filter(x => x.id_pontuacao === pontuacao.pontuacao.id)
                        : [];
                    const valorPontuacao = pontoResgatado.length > 0 ? pontoResgatado[0].valor_pontuacao : null;
                    const item = this.formularioPontuacao(pontuacao.id_pontuacao, pontuacao.pontuacao.sigla, valorPontuacao);
                    this.pontuacao_homologacao_atividade.insert(i, item);
                    i++;
                });

                const complemento =
                    this.controllerName === 'homologacao-curso-exterior' || this.controllerName === 'homologacao-evento' ?
                        'do ' : 'da ';

                if (this.acao !== 'visualizar' && (this.etapa === 1 || this.etapa === 3)) {
                    if (rascunhoFinal) {
                        this.cadastro.get('decisao_julgamento').setValue(rascunhoFinal.id_decisao);
                        this.cadastro.get('data_julgamento').setValue(new Date(rascunhoFinal.data_julgamento));
                        this.cadastro.get('observacao').setValue(rascunhoFinal.parecer);
                    } else {
                        this.cadastro.get('observacao').setValue(this.retornaTextoPadraoDeJulgamento(complemento + atividadeHomologacao));
                    }
                }
            }
        );
    }
    /**
     * Carrega a lista de resumo da homologacao
     */
    CarregarListaResumo() {
        const i = 0;
        this.service.ListarTodos('resumoHomologacao', { query: this.obj.id }).subscribe(
            data => {
                this.listaResumo = data;
                const resumoComissaoCrcBd = data.find(x => x.nome_perfil === 'Comissão CRC');

                if (resumoComissaoCrcBd) {
                    this.decisaoComissaoCrc = {
                        decisao: resumoComissaoCrcBd.id_situacao ===
                            Situacoes['Aguardando Câmara/Plenária - CRC - Deferido'] ||
                            Situacoes['Aguardando análise no CFC - Gestor'] ?
                            'Deferido' : 'Indeferido',
                        parecer: resumoComissaoCrcBd.observacao
                    }
                }
            }
        );
    }
    /**
     * Método criado para carregar cada formulario de pontuação no FormArray.
     * @param cod Codigo da pontuacao
     * @param text sigla da pontuacao
     */
    formularioPontuacao(cod: number, text: string, pontoResgatado: number) {
        return this.formBuilder.group({
            valor_pontuacao: [null],
            valor: [pontoResgatado ? pontoResgatado : 0, [Validators.required, Validators.min(0)]],
            id_pontuacao: [cod],
            label: [text]
        })
    }

    validaRascunho(): string {
        const isDeferimento = Number.parseInt(this.cadastro.get('decisao_julgamento').value) === TipoDecisao.Deferir;

        if (!(this.cadastro.controls.pontuacao_homologacao_atividade.valid &&
            this.cadastro.controls.observacao.valid &&
            this.cadastro.controls.data_julgamento.valid)) {
            return 'É necessário preencher todos os campos para prosseguir com a solicitação.';
        }

        if (isDeferimento && !(this.cadastro.get('pontuacao_homologacao_atividade').value.some(x => x.valor > 0))) {
            return 'Para deferir essa Atividade é necessário que pelo menos uma das notas seja maior que zero!';
        }
    }

    montarRascunho(idHomologacaoDaAtividade: number): RascunhoDeJulgamento {
        const rascunho = new RascunhoDeJulgamento();
        rascunho.id = 0;
        rascunho.id_homologacao = idHomologacaoDaAtividade;
        rascunho.id_decisao = this.cadastro.get('decisao_julgamento').value;
        rascunho.parecer = this.cadastro.get('observacao').value;
        rascunho.data_julgamento = this.cadastro.get('data_julgamento').value;
        rascunho.perfil = this.etapa === 1 ? 'Comissão CRC' : 'Comissão CFC';
        this.montarPontuacaoDoRascunho(rascunho);

        return rascunho;
    }

    montarPontuacaoDoRascunho(rascunho: RascunhoDeJulgamento) {
        const pontuacaoDoRascunho = this.cadastro.get('pontuacao_homologacao_atividade').value;

        pontuacaoDoRascunho.forEach(element => {
            const objeto = new PontuacaoRascunhoDeJulgamento();
            objeto.id = 0;
            objeto.id_rascunho_de_julgamento = rascunho.id;
            objeto.id_pontuacao = element.id_pontuacao;
            objeto.perfil = rascunho.perfil;
            objeto.valor_pontuacao = element.valor;
            rascunho.pontuacao_rascunho_de_julgamento.push(objeto);
        });
    }

    salvarRascunho(idHomologacaoDaAtividade: number) {
        const mensagem = this.validaRascunho();

        if (mensagem) {
            this.showMsgWarn(mensagem);
            return;
        }

        this.confirmacao.confirm({
            header: 'Mensagem de Confirmação',
            message: 'Deseja realmente prosseguir com a criação do Rascunho de Julgamento da Homologação desse Curso?',
            accept: () => {
                this.observableUtilPanelDoc.setBlockedPanel(true);
                const rascunho = this.montarRascunho(idHomologacaoDaAtividade);
                this.service.SalvarRascunhoDeJulgamento(this.controllerName, rascunho).subscribe(mensagemDeRetorno => {
                    this.observableUtilPanelDoc.setBlockedPanel(false);
                    this.showMsgSucess(mensagemDeRetorno);
                },
                    err => {
                        this.observableUtilPanelDoc.setBlockedPanel(false);
                        this.showMsgError('Ocorreu um erro ao salvar o Rascunho do Julgamento.');
                    });
            }
        });
    }

    /**
     * Abre a modal de homologacao com os valores
     * @param valor true ou false usado pra abrir ou fechar o modal
     * @param texto valor usado no texto na etapa 1 e 3.
     * @param nomeAtividade

     */
    AbrirModal(valor: number, texto: string) {
        this.cadastro.get('observacao').reset();
        this.modal = valor;
        this.deferido = texto;
        this.cadastro.get('id_pendencia').setValue('');
        this.cadastro.markAsPristine();
    }

    retornaTextoPadraoDeJulgamento(atividadeHomologacao: string): string {
        const nomeDoEstabelecimento = this.nomeCapacitadora ? this.nomeCapacitadora : this.nomeInstituicao;
        const complemento =
            this.controllerName === 'homologacao-curso-exterior' || this.controllerName === 'homologacao-evento' ?
            'oferecido' : 'oferecida';
        if (this.etapa === 1 || this.etapa === 3) {
            this.textoDeferimento = this.montarTextoPadrao(atividadeHomologacao, complemento, nomeDoEstabelecimento);
        }

        return this.textoDeferimento;
    }

    /**
     * @param anoVigencia
     */
    retornaanoVigencia(anoVigencia: Date) {
        this.dataVigencia = anoVigencia;
    }

    montarTextoPadrao(atividadeHomologacao: string, complemento: string, nomeDoEstabelecimento: string): string {
        if (this.controllerName === 'homologacao-pos-graduacao' ||
            this.controllerName === 'homologacao-docencia' ||
            this.controllerName === 'homologacao-producao-intelectual') {

            return this.deferido === 'Deferimento' ?
                `Sou pelo ${this.deferido.toLowerCase()} do pedido de credenciamento, para o exercício de ` +
                `${new Date(this.dataVigencia.toString()).getFullYear()}, ${atividadeHomologacao}, atribuindo-se pontuação conforme tabela.` :

                `Sou pelo ${this.deferido.toLowerCase()} do pedido de credenciamento, para o exercício de ` +
                `${new Date(this.dataVigencia.toString()).getFullYear()}, ${atividadeHomologacao}.`;

        } else {
            return this.deferido === 'Deferimento' ?
                `Sou pelo ${this.deferido.toLowerCase()} do pedido de credenciamento, para o exercício de ` +
                `${new Date(this.dataVigencia.toString()).getFullYear()}, ${atividadeHomologacao} ${complemento} ` +
                `pela ${nomeDoEstabelecimento}, atribuindo-se pontuação conforme tabela.` :

                `Sou pelo ${this.deferido.toLowerCase()} do pedido de credenciamento, para o exercício de ` +
                `${new Date(this.dataVigencia.toString()).getFullYear()}, ${atividadeHomologacao} ${complemento} ` +
                `pela ${nomeDoEstabelecimento}.`;
        }
    }
    /**
    * método de validacao customizado utilizada na interface.
    */
    validation(): boolean {

        if (!this.cadastro.get('observacao').valid) {
            return false;
        }

        if (this.deferido === 'Pendente') {
            if (this.etapa !== 0 && !this.cadastro.get('id_pendencia').valid) {
                return false;
            }
        } else if (this.etapa === 0) {

            if (!this.cadastro.get('id_atividade_natureza').valid || !this.cadastro.get('id_usuario_receptor').valid) {
                return false;
            }
        } else if (this.etapa === 2) {
            if (!this.cadastro.get('id_usuario_receptor').valid) {
                return false;
            }
        } else if (this.etapa === 3 || this.etapa === 1) {
            if (this.deferido === 'Deferimento' && !this.cadastro.get('pontuacao_homologacao_atividade').valid) {
                return false;
            }
        }
        return true;
    }
    /**
    * set perfil resumo para cada etapa encontrada.
    */
    setPerfil(autonomia: boolean = false) {
        if (this.etapa === 0) {
            this.resumoHomologacao.nome_perfil = 'Gestor CRC';
        } else if (this.etapa === 1) {
            this.resumoHomologacao.nome_perfil = 'Comissão CRC';
        } else if (this.etapa === 2) {
            this.resumoHomologacao.nome_perfil = 'Gestor CFC';
        } else if (this.etapa === 3) {
            this.resumoHomologacao.nome_perfil = 'Comissão CFC';
        }

    }
    /**
     * verifica se a etapa está no gestor ou comissao.
     */
    verificaEtapa() {
        this.mostrarGestor = this.etapa === 0 || this.etapa === 2
        this.liberarBtns = true;
    }
    /**
     * set o perfil de acordo com a etapa.
     * @param pontuacao
     */
    setPerfilPnt(pontuacao: any) {
        if (this.etapa === 1) {
            pontuacao.perfil = 'Comissão CRC';
        } else {
            pontuacao.perfil = 'Comissão CFC';
        }
    }
    /**
    atribui a situacao e perfil de acordo com a fluxo
    acaoSistema = ação que esta sendo executada sendo ela confirmar pendente apto nao apto ...
     */
    setSituacaoConfirmar(resumoHomologacaoAtividade: ResumoHomologacaoCurso, acaoSistema: string,
        homologacao: HomologacaoEvento, autonomia: boolean = false) {
        // qualquer etapa se a ação for pendente terá esta situacao (Devolvido para adequação)
        if (acaoSistema == 'Pendente') {

            switch (this.etapa) {
                case 0:
                    homologacao.nome_pendencia_receptor = 'gestor crc';
                    break;
                case 1:
                    homologacao.nome_pendencia_receptor = 'comissao crc';
                    break;
                case 2:
                    homologacao.nome_pendencia_receptor = 'gestor cfc';
                    break;
                case 3:
                    homologacao.nome_pendencia_receptor = 'comissao cfc';
                    break;
            }

            let pendencia = this.cadastro.get('id_pendencia').value;

            if (pendencia == 2) {
                homologacao.nome_perfil_receptor = 'gestor crc';
                resumoHomologacaoAtividade.id_situacao = Situacoes['Aguardando análise no CRC - Gestor'];
            } else if (pendencia == 3) {
                homologacao.nome_perfil_receptor = 'gestor cfc';
                resumoHomologacaoAtividade.id_situacao = Situacoes['Aguardando análise no CFC - Gestor'];
            } else {
                // Devolvido para adequação
                resumoHomologacaoAtividade.id_situacao = Situacoes['Devolvido para Adequação'];
            }
        } else if (homologacao.nome_pendencia_receptor) {

            homologacao.nome_perfil_receptor = homologacao.nome_pendencia_receptor;
            homologacao.nome_pendencia_receptor = null;

            if (homologacao.nome_perfil_receptor === 'gestor cfc') {
                resumoHomologacaoAtividade.id_situacao = Situacoes['Aguardando análise no CFC - Gestor'];

            } else if (homologacao.nome_perfil_receptor === 'gestor crc') {
                resumoHomologacaoAtividade.id_situacao = Situacoes['Aguardando análise no CRC - Gestor'];

            } else if (homologacao.nome_perfil_receptor === 'comissao crc') {
                resumoHomologacaoAtividade.id_situacao = Situacoes['Aguardando análise no CRC - Comissão'];
            } else {
                resumoHomologacaoAtividade.id_situacao = Situacoes['Aguardando análise no CFC - Comissão'];
            }
        } else if (this.etapa === 0) {
            resumoHomologacaoAtividade.id_situacao = Situacoes['Aguardando análise no CRC - Comissão'];
            homologacao.nome_perfil_receptor = null;
            homologacao.id_usuario_receptor = this.cadastro.get('id_usuario_receptor').value;
        } else if (this.etapa === 1) {
            if (autonomia) {
                homologacao.nome_perfil_receptor = null;
                homologacao.id_usuario_receptor = null;
                if (acaoSistema === 'Deferimento') {
                    resumoHomologacaoAtividade.id_situacao = Situacoes['Aguardando Câmara/Plenária - CRC - Deferido'];
                } else {
                    this.resumoHomologacao.id_situacao = Situacoes['Aguardando Câmara/Plenária - CRC - Indeferido'];
                }
            } else {
                if (acaoSistema === 'Indeferimento') {
                    resumoHomologacaoAtividade.id_situacao = Situacoes['Aguardando Câmara/Plenária - CRC - Indeferido'];
                } else {
                    homologacao.id_usuario_receptor = null;
                    homologacao.nome_perfil_receptor = 'gestor cfc';
                    resumoHomologacaoAtividade.id_situacao = Situacoes['Aguardando Câmara/Plenária - CRC - Deferido']
                }
            }
        } else if (this.etapa === 2) {
            resumoHomologacaoAtividade.id_situacao = Situacoes['Aguardando análise no CFC - Comissão'];
            homologacao.nome_perfil_receptor = null;
            homologacao.id_usuario_receptor = this.cadastro.get('id_usuario_receptor').value;
        } else if (this.etapa === 3) {
            homologacao.nome_perfil_receptor = null;
            homologacao.id_usuario_receptor = null;
            if (acaoSistema === 'Deferimento') {
                resumoHomologacaoAtividade.id_situacao = Situacoes['Aguardando Câmara/Plenária - CFC - Deferido'];
            } else {
                this.resumoHomologacao.id_situacao = Situacoes['Aguardando Câmara/Plenária - CFC - Indeferido'];
            }
        }
    }
    /**
     * Verifica a regra de negócio para cada pontuação.
     * Regra se encontra na parametrização de natureza.
     * @param ptsForm valor da pontuação
     */
    verificarRegraPontuacao(ptsForm: number) {
        let retorno = true;
        if (!this.pontuacaoNaturezaMaxima && !this.pontuacaoNaturezaMinima) {
            return true;
        }
        if (ptsForm > this.pontuacaoNaturezaMaxima) {
            retorno = false;
        } else if (ptsForm < this.pontuacaoNaturezaMinima) {
            retorno = false;
        }
        return retorno;
    }

    /**
     * Salva um obj do tipo homologacaoAtividade ficando assim, apenas o vinculo do Id do gerenciamento do mesmo.
     * @param homologacaoAtividade
     * @param cadastro
     * @param ptsForm
     */
    CarregarDadosSalvar(homologacaoAtividade: any, cadastro: any, textoObs: string, autonomia: boolean = false) {
        homologacaoAtividade.contador = this.contador;
        homologacaoAtividade.id_usuario_receptor = cadastro.id_usuario_receptor;
        homologacaoAtividade.id = cadastro.id;
        homologacaoAtividade.id_atividade_natureza = cadastro.id_atividade_natureza;

        // resumo da homologacao
        homologacaoAtividade.resumo_homologacao = [];
        this.resumoHomologacao.data_julgamento = cadastro.data_julgamento;
        this.resumoHomologacao.id_homologacao = cadastro.id;
        this.setSituacaoConfirmar(this.resumoHomologacao, this.deferido, homologacaoAtividade, autonomia);
        this.setPerfil(autonomia);
        this.resumoHomologacao.id_usuario_emissor = cadastro.id_usuario_emissor;
        this.resumoHomologacao.observacao = textoObs;
        homologacaoAtividade.resumo_homologacao.push(this.resumoHomologacao);

    }

    FecharModal() {
        if (this.etapa === 1 || this.etapa === 3) {
            this.cadastro.get('observacao').setValue(this.textoDeferimento);
        }
        this.modal = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/base/homologacao-atividade.component.ts